import { c as _c } from "react/compiler-runtime";
import { getErrorMessage } from '@onefootprint/fetch-hosted';
import type { FootprintVariant } from '@onefootprint/footprint-js-legacy';
import Idv, { AppErrorBoundary, Logger, useGetD2PStatus, useLogStateMachine } from '@onefootprint/idv';
import type { GetD2PResponse } from '@onefootprint/types';
import { useRef } from 'react';
import useHandoffMachine from 'src/hooks/use-handoff-machine';
import Layout from '../../components/layout';
import Canceled from '../canceled';
import Complete from '../complete';
import Expired from '../expired';
import Init from '../init';
type RouterProps = {
  variant?: FootprintVariant;
};
const Router = t0 => {
  const $ = _c(33);
  const {
    variant
  } = t0;
  const [state, send] = useHandoffMachine();
  const {
    authToken,
    idDocOutcome,
    l10n
  } = state.context;
  const lastLoggedD2pError = useRef(null);
  useLogStateMachine("handoff", state);
  const t1 = !state.done;
  const t2 = authToken ?? "";
  let t3;
  if ($[0] !== send || $[1] !== state.done) {
    t3 = {
      onSuccess: data => {
        lastLoggedD2pError.current = null;
        if (!state.done) {
          send({
            type: "statusReceived",
            payload: {
              status: data.status
            }
          });
        }
      },
      onError: error => {
        const message = getErrorMessage(error);
        if (lastLoggedD2pError.current !== message) {
          lastLoggedD2pError.current = message;
          Logger.warn(`Fetching d2p status failed with error, likely indicating expired session: ${message}`, {
            location: "handoff-router"
          });
        }
        if (!state.done) {
          send({
            type: "statusReceived",
            payload: {
              isError: true
            }
          });
        }
      }
    };
    $[0] = send;
    $[1] = state.done;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      enabled: t1,
      authToken: t2,
      options: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useGetD2PStatus(t4);
  let t5;
  if ($[7] !== send) {
    t5 = () => {
      Logger.warn("Resetting handoff", {
        location: "handoff-router"
      });
      send({
        type: "reset"
      });
    };
    $[7] = send;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== state) {
    t6 = state.matches("init") && <Init />;
    $[9] = state;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== authToken || $[12] !== idDocOutcome || $[13] !== l10n || $[14] !== send || $[15] !== state) {
    t7 = state.matches("idv") && <Idv authToken={authToken} isTransfer={true} onComplete={() => {
      send({
        type: "idvCompleted"
      });
      Logger.stopSessionReplay();
    }} idDocOutcome={idDocOutcome} l10n={l10n} />;
    $[11] = authToken;
    $[12] = idDocOutcome;
    $[13] = l10n;
    $[14] = send;
    $[15] = state;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== state) {
    t8 = state.matches("complete") && <Complete />;
    $[17] = state;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== state) {
    t9 = state.matches("canceled") && <Canceled />;
    $[19] = state;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== state) {
    t10 = state.matches("expired") && <Expired />;
    $[21] = state;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t11 = <AppErrorBoundary onReset={t5}>{t6}{t7}{t8}{t9}{t10}</AppErrorBoundary>;
    $[23] = t10;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== variant) {
    t12 = <Layout variant={variant}>{t11}</Layout>;
    $[30] = t11;
    $[31] = variant;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default Router;